interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "move-to-folder" asset from the Figma selection action bar. */
const FigmaMoveToFolderIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.6667 2H8.31333C8.21333 2 8.10667 1.97333 8.01333 1.92667L5.90667 0.873333C5.63333 0.733333 5.32 0.66 5.01333 0.66H3.32667C1.49333 0.666666 -2.38419e-07 2.16 -2.38419e-07 4V12C-2.38419e-07 13.84 1.49333 15.3333 3.33333 15.3333H6.66667C7.03333 15.3333 7.33333 15.0333 7.33333 14.6667C7.33333 14.3 7.03333 14 6.66667 14H3.33333C2.23333 14 1.33333 13.1 1.33333 12V6H14.6667V8C14.6667 8.36667 14.9667 8.66667 15.3333 8.66667C15.7 8.66667 16 8.36667 16 8V5.33333C16 3.49333 14.5067 2 12.6667 2ZM1.33333 4C1.33333 2.9 2.23333 2 3.33333 2H5.02C5.12 2 5.22667 2.02667 5.32 2.07333L7.42667 3.12667C7.7 3.26667 8.01333 3.34 8.32 3.34H12.6733C13.54 3.34 14.2867 3.9 14.56 4.67333H1.33333V4.00667V4ZM16 12.6667C16 13.24 15.76 13.78 15.32 14.18L14.2867 15.1533C14.16 15.2733 13.9933 15.3333 13.8267 15.3333C13.6467 15.3333 13.4733 15.26 13.34 15.1267C13.0867 14.86 13.1 14.4333 13.3667 14.1867L14.2667 13.34H9.32C8.95333 13.34 8.65333 13.04 8.65333 12.6733C8.65333 12.3067 8.95333 12.0067 9.32 12.0067H14.2667L13.3667 11.16C13.1 10.9067 13.0867 10.4867 13.34 10.22C13.5933 9.95333 14.0133 9.94 14.28 10.1933L15.32 11.1733C15.7533 11.5667 15.9933 12.1067 15.9933 12.68L16 12.6667Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaMoveToFolderIcon;
